import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { selectPartner } from "../../store/partnerStore";
import { resolvePartnerSync } from "../../utils/partner";
import { isV2Enabled } from "../registry";
import ScreenHeader from "./ScreenHeader";

// Swaps a legacy route header for the V2 ScreenHeader when the screen is
// V2-enabled but its body is still legacy (header-only rollout).
// Non-V2 partners render the children (the legacy header) unchanged.
// resolvePartnerSync so the decision is right on the first paint, before setPartner lands.
function ScreenHeaderGate({ screen, titleKey, children }) {
  const partner = resolvePartnerSync(useSelector(selectPartner));
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!isV2Enabled(screen, partner)) return children;
  return <ScreenHeader title={t(titleKey)} onBack={() => navigate(-1)} />;
}

export default ScreenHeaderGate;
